import AUD from './AUD';
import FJD from './FJD';
import NZD from './NZD';
import PGK from './PGK';
import SBD from './SBD';
import TOP from './TOP';
import VUV from './VUV';
import WST from './WST';
import XPF from './XPF';

export const OCEANIA_CURRENCIES = {
    [AUD.codeNumeric]: AUD,
    [FJD.codeNumeric]: FJD,
    [NZD.codeNumeric]: NZD,
    [PGK.codeNumeric]: PGK,
    [SBD.codeNumeric]: SBD,
    [TOP.codeNumeric]: TOP,
    [VUV.codeNumeric]: VUV,
    [WST.codeNumeric]: WST,
    [XPF.codeNumeric]: XPF
};
